import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { LogOut, Users, UsersRound, Grid, History } from "lucide-react";

import { meApi, useMe } from "@/api/me";

const NAV = [
  { to: "/users", label: "Users", icon: Users },
  { to: "/groups", label: "Groups", icon: UsersRound },
  { to: "/apps", label: "Apps", icon: Grid },
  { to: "/audit", label: "Audit", icon: History },
];

export function AppShell({ children }: { children: ReactNode }) {
  const { data } = useMe();

  async function handleLogout() {
    try {
      const { entra_logout_url } = await meApi.logout();
      window.location.href = entra_logout_url;
    } catch {
      window.location.href = "/login";
    }
  }

  return (
    <div className="grid min-h-screen grid-cols-[240px_1fr]">
      <aside className="border-r border-white/5 bg-wm-black/40 px-5 py-6">
        <div className="mb-8 flex items-center gap-3">
          <div className="grid h-8 w-8 place-items-center rounded-lg bg-wm-purple-bright/15 text-wm-purple-bright">
            <span className="text-sm font-semibold">id</span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-sm text-wm-white">Windmill ID</div>
            <div className="text-[11px] uppercase tracking-wider text-wm-gray-100/60">
              Admin
            </div>
          </div>
        </div>

        <nav className="flex flex-col gap-1">
          {NAV.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-wm-purple-bright/15 text-wm-purple-bright"
                    : "text-wm-gray-100/80 hover:bg-white/5 hover:text-wm-white"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-10 border-t border-white/5 pt-5">
          {data ? (
            <div className="mb-3 text-xs">
              <div className="text-wm-white">{data.user.name}</div>
              <div className="text-wm-gray-100/60">{data.user.email}</div>
            </div>
          ) : null}
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 rounded-md px-2 py-1.5 text-xs text-wm-gray-100/70 transition-colors hover:bg-white/5 hover:text-wm-white"
          >
            <LogOut className="h-3.5 w-3.5" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="px-10 py-8">{children}</main>
    </div>
  );
}
